import React, { useEffect, useMemo } from "react";
import { message, Switch, Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useRepairTemplateModel } from "../repairTemplateModel";
import { IRepairTemplateDetail } from "../repairTemplateType";
import { useDictModel } from "@/views/base/dict/dictModel";
import YhTag from "@/components/YhTag";
import { momentFormat, formatNum } from "@/utils/utils";
import useNavModel from "@/model/navModel";
import { tableSize } from "@/utils/constants";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
import { repairTemplateService } from "../repairTemplateService";



export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, descRows, descTotal, rowsDescTotal, loading,
        loadData, setSelectedRowKeys, setDescRows, reset
    } = useRepairTemplateModel();

    const { getTreeNodeName } = useDictModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const { user, shopAndOrg, beShopDs } = useGlobalModel()

    useEffect(() => {
        loadData()
    }, [])

    const onLook = (id: string) => {
        let supplierEditKey = "13-9-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: id, mode: "look", },
            true
        );
    }
    const handleChangeStatus = async (status: boolean, id: string) => {

        let result = await repairTemplateService.enable({
            id,
            isEnabled: status ? 1 : 0,
            updateUser: user.username
        })

        if (result.success) {
            message.success(status ? '启用成功！' : '禁用成功！')
            loadData().then()
        } else {
            message.error('操作失败！')
        }
    }
    const defaultColumns: ColumnsType<IRepairTemplateDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t, r, i) => i + 1
        },
        // {
        //     title: '维修类型名称',
        //     width: 160,
        //     dataIndex: 'templateName',
        //     render: (text: any, res: any) => <YhTootip text={text} style={{ width: 150 }} onClick={() => onLook(res.id)} />,
        // }, 
        {
            title: '维修类型',
            width: 150,
            dataIndex: 'serviceTypeName',
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '车辆品牌',
            width: 160,
            dataIndex: 'brandName',
            render: (text: any) => <YhTootip text={text} style={{ width: '160px' }} />,
        },
        {
            title: '车辆类型',
            width: 150,
            dataIndex: 'vehicleTypeName',
            render: (text: any) => <YhTootip text={text} style={{ width: '150px' }} />,
        },
        // {
        //     title: '维修项目费用',
        //     width: 150,
        //     dataIndex: 'laborCost',
        //     render: (text: any) => <YhTootip text={text} />,
        // }, {
        //     title: '维修用料费用',
        //     width: 150,
        //     dataIndex: 'materialCost',
        // }, 
        {
            title: '备注',
            width: 220,
            dataIndex: 'remarks',
        }, {
            title: '创建人员',
            width: 150,
            dataIndex: 'createUser',
        }, {
            title: '创建时间',
            width: 130,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            align: "center",
            title: '操作',
            width: 130,
            dataIndex: 'isEnabled',
            render: (text, record) =>
            (
                <Switch
                    checkedChildren="启用"
                    unCheckedChildren="禁用"
                    defaultChecked
                    checked={text === 1}
                    onChange={(v) => handleChangeStatus(v, record.id as string)}
                />
            )
        },
    ];


    //点击行选高亮
    const onRow = (record: IRepairTemplateDetail) => {
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };
    const onRightClick = (record: IRepairTemplateDetail) => {
        setDescRows([record])
        setSelectedRowKeys([record.id as string])
    }
    const countX = (arr: any) => {
        return arr.reduce((cur: any, next: any) => {
            return cur + (next.width ? next.width : 0)
        })
    }
    return (
        <Table
            bordered
            style={{ cursor: "pointer" }}
            loading={loading}
            size={tableSize}
            rowKey={record => record.id as string}
            rowSelection={{
                onChange: (selectedRowKeys: React.Key[], selectedRows: IRepairTemplateDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setDescRows(selectedRows)
                },
                selectedRowKeys
            }}
            columns={defaultColumns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record as IRepairTemplateDetail),
                onContextMenu: (e) => {
                    e.preventDefault();
                    // setSelectedRowKeys([record.id as string]);
                    onRightClick(record)
                }

            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 370px)' }}
        />
    )
}
